import { checkUsage } from "../utils/commandUtils";
import { getPathFromRoot } from "../utils/pathUtils";

export const cat = {
    name: "cat",
    description: "Displays contents of a file",
    usage: "cat FILENAME",
    run: async (args: string[], context: any) => {
        const usageError = checkUsage(args, 1, cat.usage);
        if (usageError) return usageError;

        let name = args[0];
        let path = getPathFromRoot(context.currentDir).join("/").slice(2) ?? "";
        if (path) path = path + "/";

        if (name.endsWith(".pdf")) {
            const url = `/files/${path}${name}`;
            window.open(url, "_blank");
            return `Opening ${url}...`;
        }

        name = name.replace(".png", ".txt");

        try {
            const response = await fetch(`/files/${path}${name}`);
            const text = await response.text();

            if (text.startsWith("<")) {
                throw new Error();
            }

            return text + "\n";
        } catch {
            return `ERROR: cat - No such file: ${name}`;
        }
    }
};